import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { appointmentFormEndpoints } from '@/lib/api/endpoints';
import { formSubmissionKeys } from '@/lib/queryKeys';
import type { CreateFormSubmissionDto, FormSubmission } from '@/types/appointmentForm';
import { formSubmissionErrorMessage } from './formSubmissionErrors';

export function useCreateFormSubmission(appointmentId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<FormSubmission, CreateFormSubmissionDto>({
    mutationFn: (dto) =>
      apiPost<FormSubmission, CreateFormSubmissionDto>(
        operationsClient,
        appointmentFormEndpoints.submissionsForAppointment(appointmentId),
        dto,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: formSubmissionKeys.byAppointment(appointmentId),
      });
      toast.success('Form submitted');
    },
    showErrorToast: false,
    onError: (error) => {
      toast.error(formSubmissionErrorMessage(error));
    },
  });
}
